<div class="language-selector">
  <div class="language-selector-header">
    <h2>{{ 'languages.selector.title' | translate }}</h2>
  </div>

  <div class="language-selector-content">
    @for (option of languageOptions(); track option.value) {
      <button 
        mat-button 
        class="language-item"
        [class.selected]="isSelected(option.value)"
        (click)="selectLanguage(option.value)">
        <span class="language-flag">{{ option.flag }}</span>
        <span class="language-label">{{ option.label }}</span>
        @if (isSelected(option.value)) {
          <iconify-icon icon="mdi:check" class="check-icon"></iconify-icon>
        }
      </button>
    }
  </div>
</div>
